import React from 'react'
import { useNavigate } from 'react-router-dom'
import './NotFoundPage.css'

const NotFoundPage = () => {
  const navigate = useNavigate()

  return (
    <div className="notfound-container">
      <div className="notfound-card">
        <h1 className="notfound-title">404</h1>
        <p className="notfound-message">
          Oops! The page you are looking for does not exist or you do not have access.
        </p>
        <button className="notfound-button" onClick={() => navigate('/')}>
          Go to Home
        </button>
      </div>
    </div>
  )
}

export default NotFoundPage
